import React, { useState } from "react";
import { FaDownload, FaEye, FaFilter, FaSearch } from "react-icons/fa";

const Reports = () => {
  // Sample data for demonstration
  const reportData = [
    { id: "RPT-001", name: "Monthly Sales Report", date: "2025-04-15", status: "Complete", type: "Sales" },
    { id: "RPT-002", name: "Inventory Status", date: "2025-04-14", status: "Complete", type: "Inventory" },
    { id: "RPT-003", name: "Customer Acquisition", date: "2025-04-12", status: "Complete", type: "Customer" },
    { id: "RPT-004", name: "Financial Summary", date: "2025-04-10", status: "Processing", type: "Finance" },
    { id: "RPT-005", name: "Product Performance", date: "2025-04-08", status: "Complete", type: "Sales" },
    { id: "RPT-006", name: "Stock Levels", date: "2025-04-05", status: "Failed", type: "Inventory" },
    { id: "RPT-007", name: "Customer Retention", date: "2025-04-01", status: "Complete", type: "Customer" }
  ];

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [reportType, setReportType] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="container-fluid py-4">
      <div className="row mb-4">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="card-header bg-white d-flex justify-content-between align-items-center py-3">
              <h5 className="mb-0 fw-bold text-primary">Bulk Reports</h5>
              {/* <button className="btn btn-success">Generate New Report</button> */}
            </div>
            
            <div className="card-body">
              {/* Search and Filters */}
              <div className="row g-3 mb-4 bg-light p-3 rounded">
                <div className="col-md-6">
                  <div className="input-group">
                    {/* <span className="input-group-text bg-white">
                      <FaSearch className="text-muted" />
                    </span> */}
                    <input 
                      type="text" 
                      className="form-control border-start-0"
                      placeholder="Search reports..." 
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6 text-md-end">
                  <button 
                    className="btn btn-outline-secondary" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#filterCollapse"
                  >
                    <FaFilter className="me-2" /> Filters
                  </button>
                </div>
              </div>
              
              {/* Collapsible Filter Section */}
              <div className="collapse mb-4" id="filterCollapse">
                <div className="card card-body bg-light border-0">
                  <div className="row g-3">
                    <div className="col-md-3">
                      <label className="form-label">From Date</label>
                      <input 
                        type="date" 
                        className="form-control" 
                        value={dateFrom}
                        onChange={(e) => setDateFrom(e.target.value)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">To Date</label>
                      <input 
                        type="date" 
                        className="form-control"
                        value={dateTo}
                        onChange={(e) => setDateTo(e.target.value)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Report Type</label>
                      <select 
                        className="form-select"
                        value={reportType}
                        onChange={(e) => setReportType(e.target.value)}
                      >
                        <option value="">All Types</option>
                        <option value="Sales">Sales</option>
                        <option value="Inventory">Inventory</option>
                        <option value="Customer">Customer</option>
                        <option value="Finance">Finance</option>
                      </select>
                    </div>
                    <div className="col-md-3 d-flex align-items-end">
                      <button className="btn btn-primary me-2">Apply</button>
                      <button className="btn btn-outline-secondary">Reset</button>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Report Type Pills */}
              <div className="mb-4">
                <ul className="nav nav-pills">
                  <li className="nav-item">
                    <button className="nav-link active">All Reports</button>
                  </li>
                  <li className="nav-item">
                    <button className="nav-link">Sales</button>
                  </li>
                  <li className="nav-item">
                    <button className="nav-link">Inventory</button>
                  </li>
                  <li className="nav-item">
                    <button className="nav-link">Customer</button>
                  </li>
                  <li className="nav-item">
                    <button className="nav-link">Finance</button>
                  </li>
                </ul>
              </div>
              
              {/* Reports Table */}
              <div className="table-responsive">
                <table className="table align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Report ID</th>
                      <th>Report Name</th>
                      <th>Date Generated</th>
                      <th>Type</th>
                      <th>Status</th>
                      {/* <th>Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {reportData.map(report => (
                      <tr key={report.id}>
                        <td><span className="fw-bold">{report.id}</span></td>
                        <td>{report.name}</td>
                        <td>{report.date}</td>
                        <td>
                          <span className={`badge rounded-pill ${
                            report.type === "Sales" ? "bg-info" : 
                            report.type === "Inventory" ? "bg-warning" : 
                            report.type === "Customer" ? "bg-primary" : "bg-secondary"
                          }`}>
                            {report.type}
                          </span>
                        </td>
                        <td>
                          <span className={`badge ${
                            report.status === "Complete" ? "bg-success" : 
                            report.status === "Processing" ? "bg-warning text-dark" : "bg-danger"
                          }`}>
                            {report.status}
                          </span>
                        </td>
                        {/* <td>
                          <div className="btn-group">
                            <button className="btn btn-sm btn-outline-primary">
                              <FaDownload className="me-1" /> Download
                            </button>
                            <button className="btn btn-sm btn-outline-secondary">
                              <FaEye className="me-1" /> View
                            </button>
                          </div>
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              
              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-4">
                
                <div>
                  <span className="text-muted">Showing 1-7 of 7 reports</span>
                </div>
                <nav aria-label="Page navigation">
                  <ul className="pagination pagination-sm mb-0">
                    <li className="page-item disabled">
                      <a className="page-link" href="#" tabIndex="-1" aria-disabled="true">Previous</a>
                    </li>
                    <li className="page-item active"><a className="page-link" href="#">1</a></li>
                    <li className="page-item">
                      <a className="page-link" href="#">Next</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;